import get from "lodash/get";
import React from "react";
import { getStoryElementsByType } from "../../../utils";
import Profile from "../Profile";
import "./key-profiles.m.css";

const KeyProfiles = ({ card, cdnImage, isFireSideProfile = false }) => {
  const titles = getStoryElementsByType(card, "title");
  const descriptions = getStoryElementsByType(card, "text");
  const images = getStoryElementsByType(card, "image");
  const profileGroup = titles.map((title, index) => {
    return {
      title: title["text"],
      description: get(descriptions, `[${index}].text`, ""),
      image: get(images, `[${index}]`, ""),
    };
  });
  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");
  const profileContanerStyle = isFireSideProfile ? "fireside-profile-container" : "key-profile-container";
  return (
    <div styleName={profileContanerStyle} data-model-id="12800:77510" id={`${id.toLowerCase()}`}>
      {profileGroup.map((profile) => {
        return (
          <div styleName="div">
            <div styleName="key-profile-title" dangerouslySetInnerHTML={{ __html: profile.title }} />

            <div styleName="divider" />
            {profile.description && (
              <div styleName="key-profile-description" dangerouslySetInnerHTML={{ __html: profile.description }} />
            )}
            <div styleName="profile-wrapper">
              <Profile
                image={`${cdnImage}/${profile.image["image-s3-key"]}`}
                name={profile.image.title}
                role={profile.image["image-attribution"]}
                isSpeakerProfile={false}
                isFireSideProfile={isFireSideProfile}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default KeyProfiles;
